import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const SettingsCard = ({ title, subtitle, children, gridProps = {} }) => {
  return (
    <Grid item xs={12} {...gridProps}>
      <SoftBox
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <SoftTypography 
          variant="h6" 
          fontWeight="bold"
          color="text" 
          mb={1}
          sx={{ fontSize: "1.1rem", fontWeight: 700 }}
        >
          {title}
        </SoftTypography>
        {subtitle && (
          <SoftTypography 
            variant="caption" 
            color="text" 
            mb={2.5}
            sx={{ opacity: 0.7, fontSize: "0.75rem" }}
          >
            {subtitle}
          </SoftTypography>
        )}
        {children}
      </SoftBox>
    </Grid>
  );
};

export default SettingsCard;
